import QuoteMessageError from 'components/QuoteMessageError/QuoteMessageError.styled';

export default QuoteMessageError;
